module.exports = __webpack_public_path__ + "img/star_B.b9e5c714.svg";